import React from "react";
import * as styles from "./icon-circle.module.scss";
import { classArr } from "../helper/style-helper";
import { StyleableIcon } from "../helper/icon-helper";
import * as globals from "../styles/global.icss.scss";

export interface PlusCircleProps {
	className?: string;
	style?: React.CSSProperties;
	icon?: StyleableIcon;
}

/**
 * PlusCircle is a reusable React component that displays a circle with a plus icon in the center.
 */

export default function IconCircle(props: PlusCircleProps) {
	return (
		<div
			className={classArr(styles.plusCircle, props.className)}
			style={props.style}
		>
			{props.icon?.(24, globals.textTertiary)}
		</div>
	);
}
